import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { thirdAnalysesActions } from 'features/thirdAnalyses';

const useThirdAnalyses = () => {
  const dispatch = useDispatch();
  const getThirdAnalyses = useCallback(({ offset }) => dispatch(thirdAnalysesActions.getThirdAnalyses({ offset })), [dispatch]);
  const getThirdAnalysis = useCallback(({ id, cable }) => dispatch(thirdAnalysesActions.getThirdAnalysis({ id, cable })), [dispatch]);
  const clearLocalThirdAnalyses = useCallback(() => dispatch(thirdAnalysesActions.clearLocalThirdAnalyses()), [dispatch]);
  const clearLocalActiveThirdAnalysis = useCallback(() => dispatch(thirdAnalysesActions.clearLocalActiveThirdAnalysis()), [dispatch]);

  return {
    getThirdAnalyses,
    getThirdAnalysis,
    clearLocalThirdAnalyses,
    clearLocalActiveThirdAnalysis
  };
};

export default useThirdAnalyses;